import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../Estilos/EstiloSap.css';
import 'bootstrap/dist/css/bootstrap.css';
import '../New Template/Botones.css';
import '../New Template/Formularios1.css';
import { useAuth } from '../contextos/AuthProvider'
import { EncApi } from '../Comunes/Listas';

const GeneralCia = (props) => {
    const [criterio, setCriterio] = useState('');
    const [companias, setCompanias] = useState([]);

    const handleInputChange = (e) => {
        setCriterio(e.target.value);
    };
    const navigate = useNavigate();
    const Salir = () => {
        navigate("/");
    }
    const handleOnSubmit = (e) => {
        console.log("in submit");
        if (e.which === '13') {
            e.preventDefault();
        }
        e.preventDefault();
    };
    const { Token } = useAuth();
    const handleSearch = async () => {
        try {
            const response = await axios.get(`https://smartfecr.com:2020/SmartContrackBack/api/Companias/obtener-companias?Criterio=${criterio}`, EncApi(Token));
            setCompanias(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleDetails = (idCia) => {
        // Aquí puedes manejar la lógica para mostrar los detalles de la compañía
        props.CambiaCia(idCia);
        // console.log('Mostrar detalles para idCia:', idCia);
        navigate("/Companias/Detalle");
    };

    return (
        <div className='main-block'>

            <div className="form" onSubmit={(e) => handleOnSubmit(e)}>
                <div className='formadoShadow'>

                    <div className='tituloPantalla'>
                        <p style={{ display: 'inline-block' }}> Administración Compañias Pc Service</p>
                        <button className="botonCerrar" style={{ backgroundColor: '#f3f3f3', width: '50px' }} id="SalirHome" onClick={Salir} name="SalirHome"><i className="fa fa-times"></i></button>
                    </div>

                    <h3>Buscar Compañías</h3>
                    <div className='row'>
                        <div className='col-25'>
                            <button onClick={() => handleDetails(0)}>Nuevo</button>
                        </div>
                        <div className='col-25'>
                            <input
                                type="text"
                                value={criterio}
                                onChange={handleInputChange}
                                placeholder="Ingrese criterio de búsqueda"
                                onKeyDown={e => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        handleSearch();
                                    }
                                }}
                            />
                        </div>
                        <div className='col-25'>
                            <button onClick={handleSearch}>Buscar</button>
                        </div>
                        <div className='col-25'>

                        </div>
                    </div>



                    {companias.length > 0 && (
                        <div className="info" style={{ overflowX: 'auto' }}>
                            <table className="table-striped table table-sm'">
                                <thead>
                                    <tr>
                                        <th>Acciones</th>
                                        <th>Contrato</th>

                                        <th>cedula</th>
                                        <th>Razón Social</th>
                                        <th>Nombre Comercial</th>


                                    </tr>
                                </thead>
                                <tbody>
                                    {companias.map((compania) => (
                                        <tr key={compania.IdCia}>
                                            <td>
                                                <button onClick={() => handleDetails(compania.IdCia)}>Detalles</button>
                                            </td>
                                            <td>{compania.IdCia}</td>
                                            <td>{compania.Cedula}</td>
                                            <td>{compania.RazonSocial}</td>
                                            <td>{compania.NombreComercial}</td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                </div>

            </div>

        </div>
    );
};

export default GeneralCia;